import React from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { ToastsProvider, LoaderProvider } from './contexts'
import { persistor, store } from './store'
import { AppRouter } from './router'

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <LoaderProvider>
          <ToastsProvider>
            <AppRouter />
          </ToastsProvider>
        </LoaderProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
